import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-primary-900 via-primary-800 to-primary-900 text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div>
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-48 h-20 flex items-center justify-center">
                <img
                  src="https://public.readdy.ai/ai/img_res/d1778700-06dd-495c-ba1b-481a7ad371be.png"
                  alt="Drixem Ventures by Drixem Group Logo"
                  title="Drixem Ventures"
                  className="w-48 h-20 object-contain"
                />
              </div>
            </div>
            <p className="text-white/70 text-sm leading-relaxed mb-6">
              A <strong>Malaysian business conglomerate</strong> driving sustainable growth through Palm Oil, Manufacturing, Property Development, B2B Export Trade, Advertising &amp; Marketing, and AI IT Tech.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-lg bg-white/10 hover:bg-accent-500 transition-colors cursor-pointer"
                aria-label="LinkedIn"
              >
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-lg bg-white/10 hover:bg-accent-500 transition-colors cursor-pointer"
                aria-label="Facebook"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a
                href="https://wa.me/60122353795"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-lg bg-white/10 hover:bg-accent-500 transition-colors cursor-pointer"
                aria-label="WhatsApp"
              >
                <i className="ri-whatsapp-line text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-6">
              <a href="/about" className="hover:text-accent-300 transition-colors cursor-pointer">Quick Links</a>
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="text-white/70 hover:text-accent-300 transition-colors text-sm cursor-pointer">About Us</Link>
              </li>
              <li>
                <Link to="/divisions" className="text-white/70 hover:text-accent-300 transition-colors text-sm cursor-pointer">Our Divisions</Link>
              </li>
              <li>
                <Link to="/investor-relations" className="text-white/70 hover:text-accent-300 transition-colors text-sm cursor-pointer">Investor Relations</Link>
              </li>
              <li>
                <Link to="/digital-assets" className="text-white/70 hover:text-accent-300 transition-colors text-sm cursor-pointer">Digital Assets</Link>
              </li>
              <li>
                <Link to="/careers" className="text-white/70 hover:text-accent-300 transition-colors text-sm cursor-pointer">Careers</Link>
              </li>
              <li>
                <Link to="/contact" className="text-white/70 hover:text-accent-300 transition-colors text-sm cursor-pointer">Contact Us</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-6">
              <a href="/divisions" className="hover:text-accent-300 transition-colors cursor-pointer">Our Companies</a>
            </h4>
            <ul className="space-y-3">
              <li className="text-white/70 text-sm"><strong>Drixem Mega</strong> – Palm Oil</li>
              <li className="text-white/70 text-sm"><strong>Drixem Nexus</strong> – Manufacturing</li>
              <li className="text-white/70 text-sm"><strong>Heuliez (M)</strong> – Property Development</li>
              <li className="text-white/70 text-sm"><strong>Aravion Zeus</strong> – B2B Export</li>
              <li className="text-white/70 text-sm"><strong>Drixem Sdn Bhd</strong> – Advertising</li>
              <li className="text-white/70 text-sm"><strong>Nexa Prime</strong> – AI IT Tech</li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-6">
              <a href="/contact" className="hover:text-accent-300 transition-colors cursor-pointer">Contact Info</a>
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-map-pin-line text-accent-300"></i>
                </div>
                <span className="text-white/70 text-sm">
                  No 13, Persiaran Andalas 1, Kawasan Perindustrian Sinar Andalas, 70450 Seremban, Negeri Sembilan, Malaysia
                </span>
              </li>
              <li className="flex items-start space-x-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-mail-line text-accent-300"></i>
                </div>
                <a href="mailto:IR@drixemgroup.com" className="text-white/70 hover:text-accent-300 transition-colors text-sm cursor-pointer">
                  IR@drixemgroup.com
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-whatsapp-line text-accent-300"></i>
                </div>
                <a href="https://wa.me/60122353795" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-accent-300 transition-colors text-sm cursor-pointer">
                  WhatsApp: +6012-2353795
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-phone-line text-accent-300"></i>
                </div>
                <a href="tel:+60122353795" className="text-white/70 hover:text-accent-300 transition-colors text-sm cursor-pointer">
                  +6012-2353795
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/20 mt-12 pt-8 flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
          <p className="text-white/60 text-sm">
            &copy; {currentYear} Drixem Group. All rights reserved.
          </p>
          <p className="text-white/60 text-sm">
            Developed by Drixem Group IT Division
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
